"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import BaseToolbarButtonProp from "./BaseToolbarButton";
import { Messages } from "Messages";
import { d5TableExport } from "Actions/Table/D5TableActions";

var ExportToXlsButton =
/*#__PURE__*/
function (_BaseToolbarButtonPro) {
  _inherits(ExportToXlsButton, _BaseToolbarButtonPro);

  function ExportToXlsButton(_ref) {
    var _this;

    var formUUID = _ref.formUUID,
        isContextMenu = _ref.isContextMenu,
        title = _ref.title,
        rest = _objectWithoutProperties(_ref, ["formUUID", "isContextMenu", "title"]);

    _classCallCheck(this, ExportToXlsButton);

    var props = _objectSpread({
      isContextMenu: isContextMenu,
      text: title || Messages.Controls.Export,
      hint: title || Messages.Controls.Export,
      elementAttr: {
        'class': "table-form-export-button"
      }
    }, rest);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExportToXlsButton).call(this, props));
    isContextMenu ? _this._props.UUID = formUUID : _this._props.options.UUID = formUUID;
    if (isContextMenu) _this.setOptions({
      template: null
    });
    return _this;
  }

  _createClass(ExportToXlsButton, [{
    key: "items",
    value: function items() {
      return [{
        text: Messages.Controls.ExportAll,
        icon: 'exportxlsx'
      }, {
        text: Messages.Controls.ExportSelected,
        icon: 'exportselected'
      }];
    }
  }, {
    key: "itemTemplate",
    value: function itemTemplate(data, index, element) {
      var result = $("<div>").addClass('d5popover-with-list-li');

      if (!data.text) {
        return $("<span class=\"icon menu-dpdown\"><i class=\"dx-icon dx-icon-export\"/></span>");
      }

      $("<div>").addClass("dx-icon dx-icon-".concat(data.icon)).appendTo(result);
      $("<div>").text(data.text).appendTo(result);
      element.hover(function () {
        $(this).css('background-color', '#f2f2f2');
      }, function () {
        $(this).css('background-color', '');
      });
      return result.appendTo(element);
    }
  }, {
    key: "template",
    value: function template() {
      var _this2 = this;

      return $('<div class="custom-dropdown-menu">').dxMenu({
        dataSource: [{
          items: this.items()
        }],
        onItemClick: function onItemClick(e) {
          return _this2.onMouseDown(e);
        },
        itemTemplate: this.itemTemplate.bind(this),
        cssClass: "custom-dropdown-menu exports-dropdown-menu"
      });
    }
  }, {
    key: "onMouseDown",
    value: function onMouseDown(_ref2) {
      var itemIndex = _ref2.itemIndex,
          itemData = _ref2.itemData;
      if (itemData.hasOwnProperty('items')) return;
      this.UUID = this._isContextMenu ? this._props.UUID : this._props.options.UUID;
      var exportSelected = itemIndex === 1;
      d5TableExport(this.UUID, exportSelected);
    }
  }]);

  return ExportToXlsButton;
}(BaseToolbarButtonProp);

_defineProperty(ExportToXlsButton, "create", function (options) {
  return new ExportToXlsButton(options).props();
});

export { ExportToXlsButton as default };